import "../sass/style.scss";
import {Common} from './js/common.js';
import smoothscroll from 'smoothscroll-polyfill';

class CAPO {
  constructor() {
    this.common = new Common();
    smoothscroll.polyfill();
    this.viewDidLoad();
  }

  viewDidLoad() {
    // ページ内のすべてのデータの読み込みが完了したときに実行
    window.addEventListener('load', function () {
      // ヘッダーナビの設定
      capo.common.init_header_nav();

      // スムーズスクロール
      // capo.common.set_smooth_scroll();

      /**
       * Top KeyVisual スライダー
       * @type {Swiper}
       */
      const slider1 = new Swiper('.slider1', {
        autoplay: {
          delay: 5000,
        },
        loop: true,
        slidesPerView: 1,
        centeredSlides: true,
        speed: 600,
      });

      /**
       * Top News最新記事 スライダー
       * @type {Swiper}
       */
      const slider2 = new Swiper('.slider2', {
        centeredSlides: true,
        autoplay: {
          delay: 5000,
        },
        loop: true,
        slidesPerView: 1.8,
        spaceBetween: 24,
        breakpoints: {
          600: {
            slidesPerView: 2,
            spaceBetween: 60,
          },
          900: {
            slidesPerView: 2.8,
            spaceBetween: 60,
          },
          1000: {
            slidesPerView: 2.8,
            spaceBetween: 60,
          },
          1168: {
            slidesPerView: 3,
            spaceBetween: 60,
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 60,
          },
          1379: {
            slidesPerView: 3,
            spaceBetween: 60,
          },
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      })

    });
  }
}

window.capo = new CAPO();